import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import http from 'vue-resource'
import globals from './components'
import meta from './plugins/meta-tags'
import startup from './utils/startup-scripts'
import mediaSync from './plugins/vue-media-sync'

startup.run()
globals.register()

Vue.use(http)
Vue.use(meta)
Vue.use(mediaSync, {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  desktop: 'min-width: 1025px',
  monitor: 'min-width: 1600px'
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js